import rg4js from 'raygun4js';

if (process.env.REACT_APP_SUPPRESS_PROD_SCRIPTS !== 'true') {
  rg4js('apiKey', '' + process.env.REACT_APP_RAYGUN_API_KEY);
  rg4js('enableCrashReporting', true);
  rg4js('enablePulse', true);
  rg4js('setVersion', '' + process.env.REACT_APP_VERSION);
}
